import IconWrapper, { IconWrapperProps } from '@repo/ui/src/components/IconWrapper';

interface SkewerIconProps extends IconWrapperProps {
  color?: string;
}

const SkewerIcon = ({ color, ...rest }: SkewerIconProps) => (
  <IconWrapper viewBox="0 0 32 32" width="32" height="32" {...rest}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M0,13.2857143 L0,17.8571429 L8,17.8571429 C8.63085714,17.8571429 9.14285714,18.3691429 9.14285714,19 C9.14285714,19.6308571 9.65485714,20.1428571 10.2857143,20.1428571 L32,20.1428571 L13.8662857,17.0154286 C12.4971429,16.5394286 12.4971429,14.6034286 13.8662857,14.1274286 L32,11 L10.2857143,11 C9.65485714,11 9.14285714,11.512 9.14285714,12.1428571 C9.14285714,12.7737143 8.63085714,13.2857143 8,13.2857143 L0,13.2857143 Z"
        fill={color || 'currentColor'}
      />
    </g>
  </IconWrapper>
);

export default SkewerIcon;
